import React from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { expenseReportExpensesTable } from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { getTransactionExpenses } from "../../../api/expense-report";
import { GridComp4 } from "../../../components/GridComponents";
import { CustomCheckBox } from "../../../components/CheckboxComp";
import { getTransactionVendorExpenses } from "../../../api/transaction-type";

export default function ExpenseReportItems() {
  const [tabIndex, setTabIndex] = useState(0);
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  const [rowItem, setItems] = useState({});

  async function getTransactionExpensesData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionVendorExpenses(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setItems(data?.data);
      setLoading(false);
      return {
        rows: data?.data?.data,
        total: data?.data?.dataCount,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Box className="viewDetilsBox">
        {/* <CustomCheckBox
          title={"USE MULTI CURRENCY"}
          data={rowItem?.use_multi_currency}
        /> */}
          <p>If the Vendor for this Expense Report is not in the "Expense Report Vendor" drop-down list, please type in the name of the Vendor in the "New Vendor Text" field.</p>
        <Tabs
          value={tabIndex}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
      
          <Tab label={`Expenses  ${rowItem?.expensetotal}`} />
        </Tabs>
        {/*----------Expenses------------*/}
        <TabPanel value={tabIndex} index={0}>
          <AgGridPaginatedTable
            getTableRows={getTransactionExpensesData}
            columns={expenseReportExpensesTable}
            refreshCounter={0}
          />
        </TabPanel>
      </Box>
    </>
  );
}
